export class CTipsSP {
    private m_mc:fgui.GMovieClip;

    constructor(mc:fgui.GMovieClip) {
        this.m_mc = mc;
    }

    public ResetDM():void {  }
    public IsVisible():boolean { return this.m_mc.visible; }
    public Hide():void { this.m_mc.visible = false; }

    public Show(frame:number, stopTm:number):void {
        this.m_mc.visible = true;
        this.m_mc.frame = frame-1;
        var that = this;
        createjs.Tween.get(this.m_mc)
                .to({visible:true}, stopTm)
                .to({visible:false}, 100);
        // createjs.Tween.get(this.m_mc)
        //         .wait(stopTm)
        //         .to({visible:false}, 100);
    }
}